export function buildChevronPoints(d: 'l' | 'r' | 'c', w: number, h: number) {
    // <polyline points={CHEVRON_POINTS} className="my-chevron" />
    if (d === 'r') return `0 ${-h / 2} ${w} 0 0 ${h / 2}`
    if (d === 'l') return `${w} ${-h / 2} 0 0 ${w} ${h / 2}`
    else return `${w / 2} ${-h / 2} ${w / 2} 0 ${w / 2} ${h / 2}`
}
